import React, { useEffect, useState } from 'react';
import { api } from '../services/api';
import { FALLBACK_CATEGORIAS, categoriaLabel, normalizeCategorias } from '../utils/categorias';

export default function CategoryFilter({ value, onChange, compact = false }) {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .getCategorias()
      .then((res) => {
        if (cancelled) return;
        setCategorias(normalizeCategorias(res.data || []) || FALLBACK_CATEGORIAS);
      })
      .catch(() => {
        if (!cancelled) setCategorias(FALLBACK_CATEGORIAS);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <div className="category-filter loading">Cargando categorías...</div>;

  const selected = value || 'Todas';

  return (
    <div className={`category-filter${compact ? ' category-filter-compact' : ''}`}>
      <div className="category-filter-scroll" role="tablist" aria-label="Categorías">
        {categorias.map((cat) => {
          const label = cat.label || categoriaLabel(cat.nombre);
          const active = selected === cat.nombre;
          return (
            <button
              key={cat.id ?? cat.nombre}
              type="button"
              role="tab"
              aria-selected={active}
              className={`category-chip ${active ? 'active' : ''}`}
              onClick={() => onChange(cat.nombre)}
              title={cat.blurb || label}
            >
              <span>{label}</span>
              {cat.total != null ? <em>{cat.total}</em> : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
